module.exports = __webpack_public_path__ + "img/bg4.8ce6e334.jpg";